import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Activation Handoff — Stage 6 redirect.
 *
 * Stage 6 replaced the old chat-only post-onboarding redirect with a
 * dedicated 4-path activation surface at /welcome. This file is kept as
 * a thin redirect for any inbound link still pointing at /activation
 * (older email links, the appointment "completed" round-trip, etc).
 */
const ActivationHandoffPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    // Preserve any meaningful query so future flows can branch on it.
    const completed = params.get('completed');
    const target = completed
      ? `/welcome?from=${encodeURIComponent(completed)}`
      : '/welcome';
    navigate(target, { replace: true });
  }, [navigate, params]);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: '#FBFAF6' }}
      data-testid="activation-redirect"
    >
      <p className="font-sans text-sm" style={{ color: 'rgba(14, 28, 46, 0.55)' }}>
        Opening Kindra…
      </p>
    </div>
  );
};

export default ActivationHandoffPage;
